import React from "react";
import { SiteHeader } from "../components/SiteHeader";
import { MobileCtaBar } from "../components/MobileCtaBar";
import { SiteFooter } from "../components/SiteFooter";
import { Hero } from "../components/sections/Hero";
import { Origin } from "../components/sections/Origin";
import { Journey } from "../components/sections/Journey";
import { Results } from "../components/sections/Results";
import { Transformation } from "../components/sections/Transformation";
import { SystemSection } from "../components/sections/SystemSection";
import { WhyItExists } from "../components/sections/WhyItExists";
import { Mentorship } from "../components/sections/Mentorship";
import { Outcomes } from "../components/sections/Outcomes";
import { Includes } from "../components/sections/Includes";
import { Freedom } from "../components/sections/Freedom";
import { Closing } from "../components/sections/Closing";
export function Landing() {
  return <div id="top" className="min-h-screen w-full bg-ink text-paper" data-id="element-263" data-mp="m7v6erl1yqf6">
      <SiteHeader data-id="element-264" data-mp="2b3a4ch2mkm4" />
      <main data-id="element-265" data-mp="2blexxhsu75n">
        <Hero data-id="element-266" data-mp="2bbm825ddlw9" />
        <Origin data-id="element-267" data-mp="27nw7cz4vhma" />
        <Journey data-id="element-268" data-mp="3tgl5layuz1ww" />
        <Results data-id="element-269" data-mp="3tg1yyqenrzy6" />
        <Transformation data-id="element-270" data-mp="3tfjwvd5beric" />
        <WhyItExists data-id="element-271" data-mp="3tift8x1il84o" />
        <SystemSection data-id="element-272" data-mp="3peqa4n3lzir1" />
        <Mentorship data-id="element-273" data-mp="3pdybt4imn6x2" />
        <Outcomes data-id="element-274" data-mp="3pfj7wyklaxx1" />
        <Includes data-id="element-275" data-mp="3pezyk6909hum" />
        <Freedom data-id="element-276" data-mp="3pgksbtnhwwrf" />
        <Closing data-id="element-277" data-mp="3kfwt4kp459m4" />
      </main>
      <MobileCtaBar data-id="element-278" data-mp="3kgomrpz5gx9r" />
      <SiteFooter data-id="element-279" data-mp="3khhogcj94wl1" />
    </div>;
}